// extracted by mini-css-extract-plugin
export default {"BooleanListFeature":"vu_a bhe_b"};